import { Pipe, PipeTransform } from '@angular/core';
import { DrugAutoCompleteItem } from 'src/app/shared/interfaces/drug-autocomplete-item.interface';

@Pipe({
    name: 'autocompleteDrugFilter',
    standalone: false
})
export class AutocompleteDrugFilter implements PipeTransform {
  transform(items: DrugAutoCompleteItem[], filter: DrugAutoCompleteItem): DrugAutoCompleteItem[] {
    if (items && items.length > 0) {
      return items.filter( item => item.shouldDisplay );
    }
    return [];
  }
}
